import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APISD } from "../../../../../../../../config/apisd";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../../../index.css";

const modalStyles = `
  .pj-form-section {
    grid-column: 1 / -1;
    padding-top: 2px;
  }

  .pj-form-section-title {
    margin: 0 0 10px;
    color: #17213d;
    font-size: 13px;
    font-weight: 700;
  }

  .pj-day-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 9px;
  }

  .pj-day-option {
    display: flex;
    min-height: 42px;
    align-items: center;
    gap: 9px;
    padding: 9px 11px;
    border: 1px solid #e0e6f1;
    border-radius: 10px;
    background: #ffffff;
    color: #46526d;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
  }

  .pj-day-option:hover {
    border-color: #b9c9ed;
    background: #f9fbff;
  }

  .pj-day-option.is-checked {
    border-color: #8aa5f5;
    background: #f1f5ff;
    color: #315fc5;
  }

  .pj-day-option input {
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: #3f5bea;
  }

  @media (max-width: 640px) {
    .pj-day-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`;

const emptyForm = {
  in_time: "",
  out_time: "",
  grace_period_in: "",
  grace_period_out: "",
  note: "",
  notification: false,
  days: {
    senin: false,
    selasa: false,
    rabu: false,
    kamis: false,
    jumat: false,
    sabtu: false,
    minggu: false,
  },
};

const dayOptions = [
  ["senin", "Senin"],
  ["selasa", "Selasa"],
  ["rabu", "Rabu"],
  ["kamis", "Kamis"],
  ["jumat", "Jumat"],
  ["sabtu", "Sabtu"],
  ["minggu", "Minggu"],
];

const isActiveValue = (value) =>
  value === true || value === 1 || value === "1";

export default function ModalAturWaktuUpdate(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState(emptyForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (!props?.dataUpdate) return;

    setForm({
      in_time: props.dataUpdate?.in_time || "",
      out_time: props.dataUpdate?.out_time || "",
      grace_period_in:
        props.dataUpdate?.grace_period_in !== null &&
        props.dataUpdate?.grace_period_in !== undefined
          ? String(props.dataUpdate.grace_period_in)
          : "",
      grace_period_out:
        props.dataUpdate?.grace_period_out !== null &&
        props.dataUpdate?.grace_period_out !== undefined
          ? String(props.dataUpdate.grace_period_out)
          : "",
      note: props.dataUpdate?.note || "",
      notification: isActiveValue(props.dataUpdate?.notification),
      days: {
        senin: isActiveValue(props.dataUpdate?.day_1),
        selasa: isActiveValue(props.dataUpdate?.day_2),
        rabu: isActiveValue(props.dataUpdate?.day_3),
        kamis: isActiveValue(props.dataUpdate?.day_4),
        jumat: isActiveValue(props.dataUpdate?.day_5),
        sabtu: isActiveValue(props.dataUpdate?.day_6),
        minggu: isActiveValue(props.dataUpdate?.day_7),
      },
    });
  }, [props?.dataUpdate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDayChange = (key) => {
    setForm((prev) => ({
      ...prev,
      days: {
        ...prev.days,
        [key]: !prev.days[key],
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const oldData = props?.dataUpdate || {};
    const semesterId =
      props?.filterData?.ysb_semester_id || oldData?.ysb_semester_id;
    const branchId = props?.filterData?.ysb_branch_id || oldData?.ysb_branch_id;
    const schoolId = props?.filterData?.ysb_school_id || oldData?.ysb_school_id;

    if (!semesterId) {
      ToastError.fire({ icon: "error", title: "Semester belum dipilih" });
      return;
    }

    if (!branchId) {
      ToastError.fire({ icon: "error", title: "Cabang belum dipilih" });
      return;
    }

    if (!schoolId) {
      ToastError.fire({ icon: "error", title: "Sekolah belum dipilih" });
      return;
    }

    if (!form.in_time) {
      ToastError.fire({ icon: "error", title: "Jam masuk wajib diisi" });
      return;
    }

    if (!form.out_time) {
      ToastError.fire({ icon: "error", title: "Jam keluar wajib diisi" });
      return;
    }

    setIsSubmitting(true);

    const payload = {
      id: props?.id || oldData?.id,
      ysb_semester_id: semesterId,
      ysb_branch_id: branchId,
      ysb_school_id: schoolId,
      in_time: form.in_time,
      out_time: form.out_time,
      grace_period_in: form.grace_period_in || "0",
      grace_period_out: form.grace_period_out || "",
      day_1: !!form.days.senin,
      day_2: !!form.days.selasa,
      day_3: !!form.days.rabu,
      day_4: !!form.days.kamis,
      day_5: !!form.days.jumat,
      day_6: !!form.days.sabtu,
      day_7: !!form.days.minggu,
      notification: !!form.notification,
      note: form.note || "",
      user_id: idUser,
    };

    try {
      const response = await APISD.post(
        "/api/absen-config/store",
        payload,
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Berhasil memperbarui data",
        });

        await props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
    >
      <style>{modalStyles}</style>

      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Update Pengaturan Jam</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body">
          <div className="module-form-grid">
            <div className="module-form-group">
              <label className="module-form-label" htmlFor="update_in_time">
                Jam Masuk <span>*</span>
              </label>
              <input
                id="update_in_time"
                name="in_time"
                type="time"
                className="module-form-input"
                value={form.in_time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="update_out_time">
                Jam Pulang <span>*</span>
              </label>
              <input
                id="update_out_time"
                name="out_time"
                type="time"
                className="module-form-input"
                value={form.out_time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="module-form-group">
              <label
                className="module-form-label"
                htmlFor="update_grace_period_in"
              >
                Batas Telat Masuk
              </label>
              <input
                id="update_grace_period_in"
                name="grace_period_in"
                type="number"
                min="0"
                className="module-form-input"
                value={form.grace_period_in}
                onChange={handleChange}
                placeholder="(hitungan menit)"
              />
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="update_note">
                Catatan
              </label>
              <input
                id="update_note"
                name="note"
                type="text"
                className="module-form-input"
                value={form.note}
                onChange={handleChange}
              />
            </div>

            <div className="pj-form-section">
              <p className="pj-form-section-title">Hari Berlaku</p>
              <div className="pj-day-grid">
                {dayOptions.map(([key, label]) => (
                  <label
                    className={`pj-day-option ${
                      form.days[key] ? "is-checked" : ""
                    }`}
                    htmlFor={`update-day-${key}`}
                    key={key}
                  >
                    <input
                      id={`update-day-${key}`}
                      type="checkbox"
                      checked={form.days[key]}
                      onChange={() => handleDayChange(key)}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </div>

            <div className="module-form-span-2">
              <div className="module-status-form-card">
                <div className="module-status-form-info">
                  <span className="module-status-form-title">
                    Notifikasi Alpa
                  </span>
                  <span className="module-status-form-description">
                    Aktifkan notifikasi ketika siswa tercatat tidak hadir.
                  </span>
                </div>

                <label className="module-toggle" htmlFor="update_notification">
                  <input
                    id="update_notification"
                    type="checkbox"
                    checked={form.notification}
                    onChange={() =>
                      setForm((prev) => ({
                        ...prev,
                        notification: !prev.notification,
                      }))
                    }
                  />
                  <span className="module-toggle-slider" />
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Menyimpan..." : "Update"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
